import { render } from "./DietManagement.vue?vue&type=template&id=553123e9"
import script from "./DietManagement.vue?vue&type=script&lang=js"
export * from "./DietManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__